var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  height: 80px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  overflow: inherit;\n  @media (min-width: 992px) {\n    display: ', ';\n  }\n  @media (max-width: 991.98px) {\n    height: 70px;\n    display: ', ';\n  }\n'], ['\n  width: ', ';\n  height: 80px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  overflow: inherit;\n  @media (min-width: 992px) {\n    display: ', ';\n  }\n  @media (max-width: 991.98px) {\n    height: 70px;\n    display: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

export var IframeRolexStyled = styled.iframe(_templateObject, function (props) {
  return props.mobile ? '100%' : '200px';
}, function (props) {
  return !props.mobile ? 'block' : 'none';
}, function (props) {
  return props.mobile ? 'block' : 'none';
});

export var MOBILE_SRC = 'https://static.rolex.com/clocks/2021/pga_org_mobile_HTML_320x70/rolex.html';
export var DESKTOP_SRC = 'https://static.rolex.com/clocks/2021/pga_org_desk_HTML_200x80/rolex.html';

var getSrc = function getSrc(mobile) {
  return mobile ? MOBILE_SRC : DESKTOP_SRC;
};

export default (function (_ref) {
  var mobile = _ref.mobile;
  return React.createElement(IframeRolexStyled, _extends({ src: getSrc(mobile) }, { mobile: mobile }));
});